import { Box, Chip, theme } from '@dtx-company/design-system/src'
import { CursorType } from '@dtx-company/shared-components/src'
import { FC } from 'react'
import { Icon } from '@dtx-company/shared-components/src/components/atoms/Icon/index'
import { SxProps, Theme } from '@mui/system'
import { lockIconBlackBackground } from '../../constants/assets'
import LockIcon from '@mui/icons-material/Lock'

interface ProTagProps {
  minimalIcon?: boolean
  onClick?: () => void
  isProPlus?: boolean
  cursor?: CursorType
  iconWidth?: string
  tagCopy?: string
  sx?: SxProps<Theme>
}

export const ProTag: FC<ProTagProps> = ({
  minimalIcon,
  onClick,
  isProPlus = false,
  cursor = 'auto',
  iconWidth = '100%',
  tagCopy,
  sx
}) => {
  const cursorType = onClick ? 'pointer' : cursor
  const defaultCopy = isProPlus ? 'PRO PLUS' : 'PRO'
  const copy = tagCopy ?? defaultCopy

  return minimalIcon ? (
    <Box
      data-testid={'pro-feature-tag-icon'}
      onClick={onClick}
      role={onClick ? 'button' : 'tooltip'}
      sx={{
        justifyContent: 'center',
        width: iconWidth,
        cursor: cursorType,
        my: 'auto',
        ...sx
      }}
    >
      <Icon src={lockIconBlackBackground} alt="lock icon" />
    </Box>
  ) : (
    <Chip
      startIcon={LockIcon}
      size={'small'}
      label={copy}
      onClick={onClick}
      data-testid={'pro-feature-tag-text'}
      sx={{
        height: theme.spacing(6),
        '&': { backgroundColor: theme.palette.primary.main, color: 'white' },
        '&:hover': { backgroundColor: theme.palette.primary.dark, color: 'white' },
        '.MuiChip-icon': { color: 'inherit' },
        cursor: cursorType,
        ...sx
      }}
    />
  )
}
